import colors from "assets/stylesheets/modules/colors.module.scss";

export default colors;
